const isAccountMetricsToDrop = (arg) => arg.name === 'accountMetricsToDrop';
const isTotalUnusedMetrics = (arg) => arg.name === 'totalUnusedMetrics';
const getAccountMetricsToDrop = ({ actionArgs }) => actionArgs.find(isAccountMetricsToDrop)?.value ?? [];
const getTotalUnusedMetrics = ({ actionArgs }) => actionArgs.find(isTotalUnusedMetrics)?.value;
export const metricsDataOptimizationManipulator = {
    getAccountMetricsToDrop,
    getTotalUnusedMetrics,
};
//# sourceMappingURL=metrics-data-optimization.manipulator.js.map